import {ref} from "vue";
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';


const keyboard = ref(null);
const keyboardVisible = ref(false);

let activeHandler = (input) => {};  // der Handler für den aktiven Input
let activeInputName = null;          // der aktuell aktive Input-Name
let onKeyPress = (event) => {}

function onChange(input) {
    activeHandler(input);              // nur lokalen handler aufrufen
}

function keyPress(button) {

    console.log("onKeyPress", button);
    // Shift / CapsLock Handling
    if (button === "{shift}" || button === "{shiftleft}" || button === "{shiftright}" || button === "{capslock}") {
        const layoutName = keyboard.value.options.layoutName;
        keyboard.value.setOptions({ layoutName: layoutName === "default" ? "shift" : "default" });
    }

}

function initKeyboard() {
    if (keyboard.value) return;

    keyboard.value = new Keyboard({
        onChange,
        onKeyPress: keyPress,
        physicalKeyboardHighlight: true,
        syncInstanceInputs: true,
        mergeDisplay: true
    });

    document.querySelector(".simple-keyboard").addEventListener("mousedown", function(event) {
        event.preventDefault();
        console.log('widget mousedown event');
    });
}

function registerHandler(fn) {
    activeHandler = fn || (() => {});
}

function setActiveInputName(name) {
    activeInputName = name || null;
    if (keyboard.value) keyboard.value.setOptions({ inputName: name });
}

function setInput(value, name) {
    if (!keyboard.value) return;
    const target = name ?? activeInputName ?? undefined;
    keyboard.value.setInput(value, target);
}

function showKeyboard() { keyboardVisible.value = true; }
function hideKeyboard() { keyboardVisible.value = false; }

export default function useKeyboard() {
    return {
        keyboard,
        keyboardVisible,
        initKeyboard,
        registerHandler,
        setActiveInputName,
        setInput,
        showKeyboard,
        hideKeyboard
    };
}